module.exports = __webpack_public_path__ + "img/undraw_hello_animated.acdd6cc9.svg";